import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewChild,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { AssetType } from '@rd/core/services/asset-service/asset.service';
import { DomService } from '@rd/core/services/dom/dom.service';
import { GuardhouseService } from '@rd/core/services/guardhouse/guardhouse.service';
import { GuardHouseLogoutCodes } from '@rd/types/guardhouse-logout-codes.type';
import * as CSS from 'csstype';
import { Subject } from 'rxjs';

type UserAction = 'login' | 'logout' | 'enroll' | 'changePassword';

@Component({
  selector: 'star-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StarMobileHeaderComponent {
  @HostBinding('class.rd-star-mobile-header') componentClass = true;
  @Input() authRenderState: boolean;

  @ViewChild('sidenav') sideNavRef: MatSidenav;
  sideNavOpenEvent: Subject<void> = new Subject<void>();

  isSideNavOpen = false;

  public readonly AssetType = AssetType;

  constructor(
    private domService: DomService,
    private guardhouseService: GuardhouseService,
  ) {}

  openSideNav(): void {
    this.isSideNavOpen = true;
    this.sideNavRef.open();
    this.sideNavOpenEvent.next();
  }

  closeSideNav(): void {
    this.isSideNavOpen = false;
    this.sideNavRef.close();
  }

  handleSideNavOpen(): void {
    this.domService.lockBody();
  }

  handleSideNavClose(): void {
    this.domService.unlockBody();
  }

  style(): CSS.Properties {
    if (!this.isSideNavOpen) {
      return {
        pointerEvents: 'none',
      };
    }
    return {};
  }

  handleUserAction(action: UserAction): void {
    switch (action) {
      case 'enroll':
        this.guardhouseService.redirectToEnrollUrl();
        break;

      case 'login':
        this.guardhouseService.redirectToLoginUrl();
        break;

      case 'logout':
        this.guardhouseService.redirectToLogoutUrl(
          GuardHouseLogoutCodes.IntentionalLogout,
        );
        break;

      case 'changePassword':
        this.guardhouseService.redirectToChangePasswordUrl();
        break;
    }
  }
}
